export default __webpack_public_path__ + "static/media/Lightsaber Obi-Wan ANH - Img - Wip 4_01.c51d109e.jpg";